<template>
  <div>
    <v-container fluid>
    <content-component
        :datafile="etc"/>

  <core-footer />
  </v-container>
  </div>
</template>

<script>
import {etc} from '@/data/others.js'
import ContentComponent from "../components/others";
import {mdiArrowUp} from '@mdi/js'
import 'video.js/dist/video-js.css'

export default {
  name: 'Others',
  components: {ContentComponent,
              CoreFooter: () => import ('@/components/core/Footer')},
  data: () => ({
    etc,
    icons: {
      mdiArrowUp
    },
    playerOptions: {
      // videojs options
      muted: true,
      language: 'en',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [{
        type: "video/mp4",
        src: "@/assets/HapticInterface_Asset.mp4"
      }],
      poster: "@/assets/bg.jpg",
    }
  }),


}
</script>
<style>
.center {
margin-left: auto;
margin-right: auto;
display: block
}
</style>
